import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationDiscardCavernsLootItemArgs,
  DiscardCavernsLootItemResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation DiscardCavernsLootItem($playerId: String!, $game_submode: String!, $item_id: String!) {
  discardCavernsLootItem(playerId: $playerId, game_submode: $game_submode, item_id: $item_id) {
    item_id
  }
}
`;

export default async function mutationDiscardCavernsLootItem(
  args: MutationDiscardCavernsLootItemArgs
) {
  return await graphqlClient.request<DiscardCavernsLootItemResult>(
    'discardCavernsLootItem',
    mutation,
    args
  );
}

